import { render } from "./ArtistCup.vue?vue&type=template&id=a2482cd4"
import script from "./ArtistCup.vue?vue&type=script&lang=js"
export * from "./ArtistCup.vue?vue&type=script&lang=js"

import "./ArtistCup.vue?vue&type=style&index=0&id=a2482cd4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__